import gql from 'graphql-tag';

export const SAVE_STORY = gql`
  mutation saveStoryAction(
    $resourceId: String!
    $auth0User: String
    $communityId: String
    $site: String!
  ) {
    saveStoryAction(
      input: {
        resourceId: $resourceId
        auth0User: $auth0User
        communityId: $communityId
        site: $site
      }
    ) {
      userInteraction {
        userAction
        resourceType
        resourceId
        site
      }
    }
  }
`;

export default SAVE_STORY;
